import apiFetch from '@wordpress/api-fetch';
import { __ } from "@wordpress/i18n";
import { useEffect, useState } from 'react';
import Hint from '../components/Hint/Hint';
import InputBox from '../components/InputBox/InputBox';
import MediaUploader from '../components/MediaUploader/MediaUploader';
import SingleSelect from '../components/SingleSelect/SingleSelect';
import Switch from '../components/Switch/Switch';
import { useMenu } from "../contexts/MenuContext";
import withForm from '../layouts/withForm';
const GEORestrictions = ({handleChange}) => {

    const {
        settingData,
		setSettingData
    } = useMenu();  
	const [redirectTo, setRedirectTo] = useState(settingData?.restrictions?.geo_restrictions?.redirect_to || '');
	const [pages, setPages] = useState([]);
	useEffect(() => {
		const fetchPages = async () => {
			try {
				const response = await apiFetch({ path: '/wp/v2/pages' });
				setPages(response);
			} catch (error) {
				// console.error('Error fetching pages:', error);
			}
		};
		fetchPages();
	}, []);

	const pageOptions = pages.map((page) => ({
		label: page.title.rendered || `(no title) - ID ${page.id}`,
		value: page.id.toString(),
	}));

    const countries = [
        {'AF' : 'Afghanistan',},
		{'AL' : 'Albania',},
		{'DZ' : 'Algeria',},
		{'AS' : 'American Samoa',},
		{'AD' : 'Andorra',},
		{'AO' : 'Angola',},
		{'AI' : 'Anguilla',},
		{'AQ' : 'Antarctica',},
		{'AG' : 'Antigua and Barbuda',},
		{'AR' : 'Argentina',},
		{'AM' : 'Armenia',},
		{'AW' : 'Aruba',},
		{'AU' : 'Australia',},
		{'AT' : 'Austria',},
		{'AZ' : 'Azerbaijan',},
		{'BS' : 'Bahamas',},
		{'BH' : 'Bahrain',},
		{'BD' : 'Bangladesh',},
		{'BB' : 'Barbados',},
		{'BY' : 'Belarus',},
		{'BE' : 'Belgium',},
		{'BZ' : 'Belize',},
		{'BJ' : 'Benin',},
		{'BM' : 'Bermuda',},
		{'BT' : 'Bhutan',},
		{'BO' : 'Bolivia',},
		{'BA' : 'Bosnia and Herzegovina',},
		{'BW' : 'Botswana',},
		{'BV' : 'Bouvet Island',},
		{'BR' : 'Brazil',},
		{'IO' : 'British Indian Ocean Territory',},
		{'BN' : 'Brunei Darussalam',},
		{'BG' : 'Bulgaria',},
		{'BF' : 'Burkina Faso',},
		{'BI' : 'Burundi',},
		{'KH' : 'Cambodia',},
		{'CM' : 'Cameroon',},
		{'CA' : 'Canada',},
		{'CV' : 'Cape Verde',},
		{'KY' : 'Cayman Islands',},
		{'CF' : 'Central African Republic',},
		{'TD' : 'Chad',},
		{'CL' : 'Chile',},
		{'CN' : 'China',},
		{'CX' : 'Christmas Island',},
		{'CC' : 'Cocos (Keeling) Islands',},
		{'CO' : 'Colombia',},
		{'KM' : 'Comoros',},
		{'CG' : 'Congo',},
		{'CD' : 'Congo, Democratic Republic of the',},
		{'CK' : 'Cook Islands',},
		{'CR' : 'Costa Rica',},
		{'CI' : 'Côte d\'Ivoire',},
		{'HR' : 'Croatia',},
		{'CU' : 'Cuba',},
		{'CY' : 'Cyprus',},
		{'CZ' : 'Czech Republic',},
		{'DK' : 'Denmark',},
		{'DJ' : 'Djibouti',},
		{'DM' : 'Dominica',},
		{'DO' : 'Dominican Republic',},
		{'EC' : 'Ecuador',},
		{'EG' : 'Egypt',},
		{'SV' : 'El Salvador',},
		{'GQ' : 'Equatorial Guinea',},
		{'ER' : 'Eritrea',},
		{'EE' : 'Estonia',},
		{'ET' : 'Ethiopia',},
		{'FK' : 'Falkland Islands (Malvinas)',},
		{'FO' : 'Faroe Islands',},
		{'FJ' : 'Fiji',},
		{'FI' : 'Finland',},
		{'FR' : 'France',},
		{'GF' : 'French Guiana',},
		{'PF' : 'French Polynesia',},
		{'TF' : 'French Southern Territories',},
		{'GA' : 'Gabon',},
		{'GM' : 'Gambia',},
		{'GE' : 'Georgia',},
		{'DE' : 'Germany',},
		{'GH' : 'Ghana',},
		{'GI' : 'Gibraltar',},
		{'GR' : 'Greece',},
		{'GL' : 'Greenland',},
		{'GD' : 'Grenada',},
		{'GP' : 'Guadeloupe',},
		{'GU' : 'Guam',},
		{'GT' : 'Guatemala',},
		{'GG' : 'Guernsey',},
		{'GN' : 'Guinea',},
		{'GW' : 'Guinea-Bissau',},
		{'GY' : 'Guyana',},
		{'HT' : 'Haiti',},
		{'HM' : 'Heard Island and McDonald Islands',},
		{'VA' : 'Holy See (Vatican City State)',},
		{'HN' : 'Honduras',},
		{'HK' : 'Hong Kong',},
		{'HU' : 'Hungary',},
		{'IS' : 'Iceland',},
		{'IN' : 'India',},
		{'ID' : 'Indonesia',},
		{'IR' : 'Iran, Islamic Republic of',},
		{'IQ' : 'Iraq',},
		{'IE' : 'Ireland',},
		{'IM' : 'Isle of Man',},
		{'IL' : 'Israel',},
		{'IT' : 'Italy',},
		{'JM' : 'Jamaica',},
		{'JP' : 'Japan',},
		{'JE' : 'Jersey',},
		{'JO' : 'Jordan',},
		{'KZ' : 'Kazakhstan',},
		{'KE' : 'Kenya',},
		{'KI' : 'Kiribati',},
		{'KP' : 'Korea, Democratic People\'s Republic of',},
		{'KR' : 'Korea, Republic of',},
		{'KW' : 'Kuwait',},
		{'KG' : 'Kyrgyzstan',},
		{'LA' : 'Lao People\'s Democratic Republic',},
		{'LV' : 'Latvia',},
		{'LB' : 'Lebanon',},
		{'LS' : 'Lesotho',},
		{'LR' : 'Liberia',},
		{'LY' : 'Libya',},
		{'LI' : 'Liechtenstein',},
		{'LT' : 'Lithuania',},
		{'LU' : 'Luxembourg',},
		{'MO' : 'Macao',},
		{'MK' : 'Macedonia, the former Yugoslav Republic of',},
		{'MG' : 'Madagascar',},
		{'MW' : 'Malawi',},
		{'MY' : 'Malaysia',},
		{'MV' : 'Maldives',},
		{'ML' : 'Mali',},
		{'MT' : 'Malta',},
		{'MH' : 'Marshall Islands',},
		{'MQ' : 'Martinique',},
		{'MR' : 'Mauritania',},
		{'MU' : 'Mauritius',},
		{'YT' : 'Mayotte',},
		{'MX' : 'Mexico',},
		{'FM' : 'Micronesia, Federated States of',},
		{'MD' : 'Moldova, Republic of',},
		{'MC' : 'Monaco',},
		{'MN' : 'Mongolia',},
		{'ME' : 'Montenegro',},
		{'MS' : 'Montserrat',},
		{'MA' : 'Morocco',},
		{'MZ' : 'Mozambique',},
		{'MM' : 'Myanmar',},
		{'NA' : 'Namibia',},
		{'NR' : 'Nauru',},
		{'NP' : 'Nepal',},
		{'NL' : 'Netherlands',},
		{'NC' : 'New Caledonia',},
		{'NZ' : 'New Zealand',},
		{'NI' : 'Nicaragua',},
		{'NE' : 'Niger',},
		{'NG' : 'Nigeria',},
		{'NU' : 'Niue',},
		{'NF' : 'Norfolk Island',},
		{'MP' : 'Northern Mariana Islands',},
		{'NO' : 'Norway',},
		{'OM' : 'Oman',},
		{'PK' : 'Pakistan',},
		{'PW' : 'Palau',},
		{'PS' : 'Palestinian Territory, Occupied',},
		{'PA' : 'Panama',},
		{'PG' : 'Papua New Guinea',},
		{'PY' : 'Paraguay',},
		{'PE' : 'Peru',},
		{'PH' : 'Philippines',},
		{'PN' : 'Pitcairn',},
		{'PL' : 'Poland',},
		{'PT' : 'Portugal',},
		{'PR' : 'Puerto Rico',},
		{'QA' : 'Qatar',},
		{'RE' : 'Réunion',},
		{'RO' : 'Romania',},
		{'RU' : 'Russian Federation',},
		{'RW' : 'Rwanda',},
		{'BL' : 'Saint Barthélemy',},
		{'SH' : 'Saint Helena, Ascension and Tristan da Cunha',},
		{'KN' : 'Saint Kitts and Nevis',},
		{'LC' : 'Saint Lucia',},
		{'MF' : 'Saint Martin (French part)',},
		{'PM' : 'Saint Pierre and Miquelon',},
		{'VC' : 'Saint Vincent and the Grenadines',},
		{'WS' : 'Samoa',},
		{'SM' : 'San Marino',},
		{'ST' : 'Sao Tome and Principe',},
		{'SA' : 'Saudi Arabia',},
		{'SN' : 'Senegal',},
		{'RS' : 'Serbia',},
		{'SC' : 'Seychelles',},
		{'SL' : 'Sierra Leone',},
		{'SG' : 'Singapore',},
		{'SX' : 'Sint Maarten (Dutch part)',},
		{'SK' : 'Slovakia',},
		{'SI' : 'Slovenia',},
		{'SB' : 'Solomon Islands',},
		{'SO' : 'Somalia',},
		{'ZA' : 'South Africa',},
		{'GS' : 'South Georgia and the South Sandwich Islands',},
		{'SS' : 'South Sudan',},
		{'ES' : 'Spain',},
		{'LK' : 'Sri Lanka',},
		{'SD' : 'Sudan',},
		{'SR' : 'Suriname',},
		{'SJ' : 'Svalbard and Jan Mayen',},
		{'SZ' : 'Swaziland',},
		{'SE' : 'Sweden',},
		{'CH' : 'Switzerland',},
		{'SY' : 'Syrian Arab Republic',},
		{'TW' : 'Taiwan, Province of China',},
		{'TJ' : 'Tajikistan',},
		{'TZ' : 'Tanzania, United Republic of',},
		{'TH' : 'Thailand',},
		{'TL' : 'Timor-Leste',},
		{'TG' : 'Togo',},
		{'TK' : 'Tokelau',},
		{'TO' : 'Tonga',},
		{'TT' : 'Trinidad and Tobago',},
		{'TN' : 'Tunisia',},
		{'TR' : 'Turkey',},
		{'TM' : 'Turkmenistan',},
		{'TC' : 'Turks and Caicos Islands',},
		{'TV' : 'Tuvalu',},
		{'UG' : 'Uganda',},
		{'UA' : 'Ukraine',},
		{'AE' : 'United Arab Emirates',},
		{'GB' : 'United Kingdom',},
		{'US' : 'United States',},
		{'UM' : 'United States Minor Outlying Islands',},
		{'UY' : 'Uruguay',},
		{'UZ' : 'Uzbekistan',},
		{'VU' : 'Vanuatu',},
		{'VE' : 'Venezuela, Bolivarian Republic of',},
		{'VN' : 'Viet Nam',},
		{'VG' : 'Virgin Islands, British',},
		{'VI' : 'Virgin Islands, U.S.',},
		{'WF' : 'Wallis and Futuna',},
		{'EH' : 'Western Sahara',},
		{'YE' : 'Yemen',},
		{'ZM' : 'Zambia',},
		{'ZW' : 'Zimbabwe',},
    ];
    const [filteredCountries, setFilteredCountries] = useState(countries);

    // Calculate country- columns for the grid - split evenly into 4 columns
    const createCountriesColumns = () => {
        if (filteredCountries.length === 0) return [[], [], [], []];

        const columnSize = Math.ceil(filteredCountries.length / 4);
        return [
            filteredCountries.slice(0, columnSize),
            filteredCountries.slice(columnSize, columnSize * 2),
            filteredCountries.slice(columnSize * 2, columnSize * 3),
            filteredCountries.slice(columnSize * 3),
        ];
    };
    const columns = createCountriesColumns();  
	const toggleBlocklist = (value) => {
		setSettingData((prev) => {
			const blockedCountries =
				prev?.restrictions?.geo_restrictions?.blocked_countries || [];

			const updatedCountries = blockedCountries.includes(value)
				? blockedCountries.filter((country) => country !== value) // remove
				: [...blockedCountries, value]; // add

			return {
				...prev,
				restrictions: {
					...prev.restrictions,
					geo_restrictions: {
						...prev.restrictions.geo_restrictions,
						blocked_countries: updatedCountries,
					},
				},
			};
		});
	}; 
	const blockedCountries = settingData?.restrictions?.geo_restrictions?.blocked_countries || [];
	const [activeFilter, setActiveFilter] = useState('all');
	const [filteProcessing, setFilterProcessing] = useState(false);
	const showAllCountries = () => {
		setFilterProcessing(true);
		setActiveFilter('all');
		setFilteredCountries(countries);
		setFilterProcessing(false);
	};
	const showAllowedCountries = () => {
		setFilterProcessing(true);
		setActiveFilter('allowed');
		setFilteredCountries(
			countries.filter((country) => {
				const [code] = Object.keys(country);
				return !blockedCountries.includes(code);
			})
		);
		setFilterProcessing(false);
	};

	const showBlockedCountries = () => {
		setFilterProcessing(true);
		setActiveFilter('blocked');
		setFilteredCountries(
			countries.filter((country) => {
				const [code] = Object.keys(country);
				return blockedCountries.includes(code);
			})
		);
		setFilterProcessing(false);
	};
	
	// const allChecked = blockedCountries.length === countries.length;
	const allChecked = (filteredCountries.length && blockedCountries.length === filteredCountries.length)?1:0;
	// Toggle all: if all are blocked, uncheck all; otherwise check all
	const toggleAllCountries = () => {
		const allCodes = countries.map((c) => Object.keys(c)[0]);
		setSettingData((prev) => ({
			...prev,
			restrictions: {
				...prev.restrictions,
				geo_restrictions: {
				...prev.restrictions.geo_restrictions,
				blocked_countries:
					blockedCountries.length === countries.length ? [] : allCodes,
				},
			},
		}));
	};
	const handleRedirectToChange = (name, value) => {
        setRedirectTo(value);
        handleChange('restrictions.geo_restrictions.redirect_to', value);
    };
    return (
        <>
			{/* {console.log(blockedCountries)} */}
            <div className="setting-unit pb-lg mb-lg border-bottom">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Blocked Countries", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Select countries from which access will be blocked", "ultimate-security")}</p>
                        </div>
                    </div>
                    
                </div>
            </div>
			
			<div className="setting-unit pb-lg mb-lg">
				<div className="row">
					<div className="col-lg-5">
						<div className="title-group">
							<h5 className="pl-heading-1 fw-600 text-text">{__("Restrict site access to visitors who aren't logged in or allowed by IP address", "ultimate-security")}</h5>
						</div>
					</div>
					<div className="col-lg-7">
						<div className="row justify-content-between">
							<div className="col-lg-10">
								<div className="title-group d-flex align-items-center ">
									<Hint position="top" content={__("Enable/disable restrictions", "ultimate-security")}/>
									<h6 className="pl-heading-1 fw-600 text-text">{__("Enable", "ultimate-security")}</h6>
								</div>
								
							</div>
							
							<div className="col-auto">
								<Switch 
									name="restrictions.geo_restrictions.firewall"
									checked={settingData?.restrictions?.geo_restrictions?.firewall}
									onChange={handleChange} 
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Handle restricted visitors", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint position="top" content={__("Redirect restricted visitors", "ultimate-security")}/>
                                    <SingleSelect
                                        options={[
                                            { label: 'Send them to the WordPress login screen', value: 'login_screen' },
                                            { label: 'Redirect them to a specified web address', value: 'web_address' },
                                            { label: 'Show them a simple message', value: 'message' },
                                            { label: 'Show them a page', value: 'page' }
                                        ]}
                                        initialValue={settingData?.restrictions?.geo_restrictions?.redirect_to || 'login_screen'}
                                        name="restrictions.geo_restrictions.redirect_to"
                                        selected={settingData?.restrictions?.geo_restrictions?.redirect_to}
                                        handleChange={handleRedirectToChange}
                                    />
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {redirectTo === 'web_address' && (
                <>
                    <div className="setting-unit pb-lg mb-lg">
                        <div className="row">
                            <div className="col-lg-5">
                                <div className="title-group">
                                    <h5 className="pl-heading-1 fw-600 text-text">{__("Redirect web address", "ultimate-security")}</h5>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="row justify-content-between">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center">
                                            <Hint position="top" content={__("Redirect web address", "ultimate-security")}/>
                                            <InputBox 
                                                type="url" 
                                                name="restrictions.geo_restrictions.redirect_web_address" 
                                                placeholder="https://example.com"
                                                value={settingData?.restrictions?.geo_restrictions?.redirect_web_address} 
                                                handleChange={handleChange} 
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="setting-unit pb-lg mb-lg">
                        <div className="row">
                            <div className="col-lg-5">
                                <div className="title-group">
                                    <h5 className="pl-heading-1 fw-600 text-text">{__("Redirect to same path", "ultimate-security")}</h5>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="row justify-content-between">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint position="top" content={__("Enable redirect to same path", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Enable", "ultimate-security")}</h6>
                                        </div>
                                        <div className="content-below-with-hint">                                    
                                            <p className="pl-body text-text">{__( "Send restricted visitor to same path (relative URL) at the new web address", "ultimate-security" )}</p>
                                        </div>
                                    </div>
                                    
                                    <div className="col-auto">
                                        <Switch 
                                            name="restrictions.geo_restrictions.redirect_to_same_path"
                                            checked={settingData?.restrictions?.geo_restrictions?.redirect_to_same_path} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="setting-unit pb-lg mb-lg">
                        <div className="row">
                            <div className="col-lg-5">
                                <div className="title-group">
                                    <h5 className="pl-heading-1 fw-600 text-text">{__("Redirection status code", "ultimate-security")}</h5>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="row justify-content-between">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint position="top" content={__("Redirect status code", "ultimate-security")}/>
                                            <SingleSelect
                                                options={[
                                                    { label: '302 undefined', value: '302' },
                                                    { label: '301 permanent', value: '301' },
                                                    { label: '307 temporary', value: '307' },
                                                ]}
                                                initialValue={settingData?.restrictions?.geo_restrictions?.redirection_status_code || '302'}
                                                name="restrictions.geo_restrictions.redirection_status_code"
                                                selected={settingData?.restrictions?.geo_restrictions?.redirection_status_code}
                                                handleChange={handleChange}
                                            />
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </>
            )}
            {redirectTo === 'message' && (
                <>
                    <div className="setting-unit pb-lg mb-lg">
                        <div className="row">
                            <div className="col-lg-5">
                                <div className="title-group">
                                    <h5 className="pl-heading-1 fw-600 text-text">{__("Header background image", "ultimate-security")}</h5>                         
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="row justify-content-between">
                                    <div className="col-lg-10">                                
                                        <MediaUploader 
                                            data={settingData?.restrictions?.geo_restrictions?.header_background_image} 
                                            name='restrictions.geo_restrictions.header_background_image' 
                                            handleChange={handleChange}
                                            options = {{
                                                frame:{
                                                    title: __("Select or Upload Image", "ultimate-security"),
                                                },
                                                library: {type: 'image'},
                                                buttons: {
                                                    upload: __("Upload Image", "ultimate-security"),
                                                    remove: __("Remove", "ultimate-security"),
                                                    select: __("Use this image", "ultimate-security")                                            
                                                },
                                                hint: __("No Hint", "ultimate-security"),
                                                message: {
                                                    size: 'Size: Recommended 420x420 px <br> File Support: png',
                                                    info: 'Select the background image for the header'
                                                } 
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> 

                    <div className="setting-unit pb-lg mb-lg">
                        <div className="row">
                            <div className="col-lg-5">
                                <div className="title-group">
                                    <h5 className="pl-heading-1 fw-600 text-text">{__("Restriction message", "ultimate-security")}</h5>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="row justify-content-between">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center">
                                            <Hint position="top" content={__("Restriction message", "ultimate-security")}/>
                                            <textarea 
                                                className="form-control"
                                                value={settingData?.restrictions?.geo_restrictions?.restriction_message}
                                                onChange={(e)=> handleChange('restrictions.geo_restrictions.restriction_message', e.target.value)}
                                            />
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
            {redirectTo === 'page' && (
                <>
                    <div className="setting-unit pb-lg mb-lg">
                        <div className="row">
                            <div className="col-lg-5">
                                <div className="title-group">
                                    <h5 className="pl-heading-1 fw-600 text-text">{__("Restricted notice page", "ultimate-security")}</h5>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="row justify-content-between">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint position="top" content={__("Restricted notice page", "ultimate-security")}/>
                                            <SingleSelect
                                                options={pageOptions}
                                                initialValue={settingData?.restrictions?.geo_restrictions?.restricted_notice_page || ''}
                                                name="restrictions.geo_restrictions.restricted_notice_page"
                                                selected={settingData?.restrictions?.geo_restrictions?.restricted_notice_page}
                                                handleChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
            <div className="setting-unit">
                {/* {console.log(filteredCountries)} */}
                <div className="checkbox-group-table">
                    <div className="checkbox-group-sidebar">
                        <div className="sidebar-header"><span>Group (Total/Granted)</span></div>
                        <div className="quick-filter">
                            <div className="sidebar-menu">
                                <div className="sidebar-dropdown">
                                    <div className={`dropdown-item ${activeFilter == 'all'?'active':''}`}>
										<button disabled={filteProcessing} onClick={showAllCountries}>All</button>
									</div>
                                    <div className={`dropdown-item ${activeFilter == 'allowed'?'active':''}`}>
                                        <button disabled={filteProcessing} onClick={showAllowedCountries}>Allowed Countries</button>
                                    </div>
                                    <div className={`dropdown-item ${activeFilter == 'blocked'?'active':''}`}>
                                        <button disabled={filteProcessing} onClick={showBlockedCountries}>Blocked Countries</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="checkbox-group-content">
                        <div className="content-header">
                            <div className="toggle-option"><span>Block all</span>
                                <div className="position-relative ultimate-security-switcher">
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={allChecked}
          									onChange={toggleAllCountries}
                                        />
                                        <em data-on="Active" data-off="Inactive"></em>
                                        <span></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="checkbox-group-grid">
                            {columns.map((column, columnIndex) => (
                                <div key={columnIndex} className="checkbox-group-column">
                                    {/* {console.log(column)} */}
                                    {column.map((country, index) => (
                                    <div key={`${country}-${index}`} className="checkbox-group-item">
										{/* {console.log(settingData?.restrictions?.geo_restrictions?.blocked_countries)} */}
										{/* {console.log(Object.keys(country)[0])} */}
                                        <input
                                        type="checkbox"
                                        checked={settingData?.restrictions?.geo_restrictions?.blocked_countries.includes(Object.keys(country)[0])}
                                        id={Object.keys(country)[0]}
                                        value={Object.keys(country)[0]}
                                        onChange={() => toggleBlocklist(Object.keys(country)[0])}
                                        // disabled={isReadOnly}
                                        />
                                        <label htmlFor={Object.keys(country)}>
                                        {Object.values(country)[0]}
                                        </label>
                                    </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default withForm(GEORestrictions, 'restrictions.geo_restrictions');